export function Section({ children }: { children: React.ReactNode }) {
  return (
    <section className="flex flex-col gap-4 text-base text-grey-read">
      {children}
    </section>
  );
}

export function Heading({
  children,
  id
}: {
  children: React.ReactNode;
  id?: string;
}) {
  return (
    <h2 id={id} className="text-title-md">
      {children}
    </h2>
  );
}

export function SubHeading({ children }: { children: React.ReactNode }) {
  return <h3 className="text-title-sm">{children}</h3>;
}

export function UnorderedList({ children }: { children: React.ReactNode }) {
  return <ul className="ml-8 list-disc indent-2">{children}</ul>;
}

export function Anchor({
  children,
  href
}: {
  children: React.ReactNode;
  href: string;
}) {
  return (
    <a className="font-semibold underline" href={href}>
      {children}
    </a>
  );
}
